import { EntityFilterRestriction, EntityFilters } from "../EntityList/types";

/**
 * Подмешивает URL/menu restriction в сохранённые фильтры таблицы.
 * Не трогает иерархию, если последний уровень уже с тем же первым значением toSearch — иначе
 * перезаписывает весь hierarchicalFilter одним уровнем (как «жёсткий» сценарий restriction).
 */
export const withFilterRestriction = (
  filters: EntityFilters | undefined,
  filterRestriction?: EntityFilterRestriction,
): EntityFilters | undefined => {
  if (!filterRestriction) {
    return filters;
  }

  const { filterAttrId, filterValueStr } = filterRestriction ?? {};
  const { hierarchicalFilter } = filters ?? {};
  const lastFilter =
    hierarchicalFilter?.filters[hierarchicalFilter.filters.length - 1];

  /* Совпадение только по первому элементу toSearch — так бэкенд/UI обычно задают «текущее» значение листа. */
  if (lastFilter?.filterValue?.toSearch[0] === filterValueStr) {
    return filters;
  }

  return {
    ...filters,
    hierarchicalFilter: {
      filters: [
        {
          attrId: filterAttrId,
          filterValue: {
            name: filterValueStr,
            toSearch: [filterValueStr],
          },
        },
      ],
      searchValue: [filterValueStr],
    },
  };
};
